import { render, staticRenderFns } from "./DesignOppositionOwnerForm.vue?vue&type=template&id=33034c3e&"
import script from "./DesignOppositionOwnerForm.vue?vue&type=script&lang=js&"
export * from "./DesignOppositionOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignOppositionOwnerForm.vue?vue&type=style&index=0&id=33034c3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports